module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "p01"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ct"
  }, [_c('b', [_vm._v("PART ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "cst"
  }, [_c('b', [_vm._v("Physicians Must Be Altruistic")])]), _vm._v(" "), _c('div', {
    staticClass: "atx1"
  }, [_c('div', {
    staticClass: "tx1"
  }, [_vm._v("PHYSICIANS must be compassionate and empathetic in caring for patients, and must be trustworthy and truthful in all their professional dealings. They must bring to the study and practice of medicine those character traits, attitudes, and values that underpin ethical and beneficent medical care. They must understand the history of medicine, the nature of medicine’s social compact, the ethical precepts of the medical profession, and their obligations under law. At all times they must act with integrity, honesty, and respect for patients’ privacy, and respect for the dignity of patients as persons. In all of their interactions with patients, they must seek to understand the meaning of the patients’ stories in the context of the patients’ beliefs and family and cultural values. They must avoid being judgmental when the patients’ beliefs and values conflict with their own. They must continue to care for dying patients even when the disease-specific therapy is no longer available or desired.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-771011fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/robe_9781595587800_oeb_p01_r1.vue
// module id = 75
// module chunks = 0